const apiBaseUrl =
	process.env.REACT_APP_API_BASE_URL ||
	(process.env.NODE_ENV === "production"
		? "https://data.marc.org/trans-api/api"
		: "http://localhost:5037/api");

export default apiBaseUrl;
